module.exports = __webpack_public_path__ + "static/media/ultramax-starter-package.8132fa2e.png";